import { AuthService } from '@services/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { trigger, state, style } from '@angular/animations';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';

import { DatatableBaseComponent } from '@components/datatable-base.component';
import { UiService } from '@services/ui.service';
import { Contact } from '@classes/contact';
import { ContactsService } from '@services/contacts.service';
import { MatPaginator } from '@angular/material/paginator';
import { RoleName } from '@enums/role-name.enum';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' }))
    ])
  ]
})
export class ContactsComponent extends DatatableBaseComponent implements OnInit {
  contacts: Contact[];
  isDispatcher: boolean;
  displayedColumns = ['client', 'firstname', 'lastname', 'gsm', 'phone', 'email', 'fax', 'locality', 'postalCode', 'street', 'streetNumber', 'service', 'site', 'actions'];
  dataSource: MatTableDataSource<Contact>;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    protected uiSrv: UiService,
    private route: ActivatedRoute,
    private contactsSrv: ContactsService,
    private authSrv: AuthService
  ) {
    super(uiSrv);
  }

  ngOnInit() {
    super.ngOnInit();

    this.isDispatcher =
    this.authSrv.getUser().role.name === RoleName.bizzdev ||
    this.authSrv.getUser().role.name === RoleName.super_admin ||
    this.authSrv.getUser().role.name === RoleName.admin ||
    this.authSrv.getUser().role.name === RoleName.admin_subcontractor ||
    this.authSrv.getUser().role.name === RoleName.dispatcher;

    this.getRouteData();
    this.initSubscriptions();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.contacts);
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'client': {
          return item.client.name;
        }
        default: return item[property];
      }
    };
    this.dataSource.sort = this.sort;

    this.dataSource.filterPredicate = (data, filter: string) => {
      const accumulator = (currentTerm, key) => {
        switch (key) {
          case 'client': return currentTerm + data.client.name;
          default: return currentTerm + data[key];
        }
      };
      const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
      // Transform the filter by converting it to lowercase and removing whitespace.
      const transformedFilter = filter.trim().toLowerCase();
      return dataStr.indexOf(transformedFilter) !== -1;
    };
  }

  private getRouteData(): void {
    this.route.data
      .subscribe((data: { contacts: Contact[] }) => {
        this.contacts = data.contacts;
        this.initTable();
      });
  }

  private initSubscriptions(): void {
    this.addSubscription(
      this.contactsSrv.contactsListChanged
        .subscribe(contacts => {
          this.dataSource.data = contacts || [];
          this.dataSource.sort = this.sort;
          this.onEditFinished();
        })
    );
  }

  delete(idContact: string) {
    const confirmation = confirm('Êtes-vous certain de vouloir supprimer ce contact ?');

    if (confirmation) {
      this.contactsSrv.delete(idContact).subscribe(() => {
        this.uiSrv.showSnackbar('contacts.deleted', true);
      });
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
